import React from "react";
import PropTypes from "prop-types";
import Materialicon from "../../helpers/Materialicon";
import LoaderInline from "../../helpers/LoaderInline";

const DashboardCard= (props) => (		  
	<div className={`dashboard-card ${props.class ? props.class : ""}`}>
		<h3 className="card-title">{props.text}</h3>
		<div className="media">
			<div className="media-left meida media-middle">
				<span><Materialicon icon={props.icon}/></span>
			</div>
			<div className="media-body media-text-right">
				<h2 className="value">{props.isLoading ? <LoaderInline color="#fff" width="30" height="30" /> : <React.Fragment>{props.value === "" ? 0 : props.value}</React.Fragment>}</h2>
				<p>{props.text}</p>
			</div>
		</div>
	</div>
);

DashboardCard.defaultProps = {
	value: null,
	class: "",
	isLoading: false,
};

DashboardCard.propTypes = {
	isLoading: PropTypes.bool,
	icon: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	class: PropTypes.string,
};
export default DashboardCard;



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/DashboardCard.js